import { CrashedRocket } from '@/assets/svgAsComponents/crashed-rocket';
import { CrashedRocketDark } from '@/assets/svgAsComponents/crashed-rocket-dark';
import { useContext } from 'react';
import { ThemeContext } from '@/context/theme-context';
import { useNavigate } from '@tanstack/react-router';
import { SquaredBackground } from './squared-background';
import { Button } from './ui/button';
import { useTranslation } from 'react-i18next';

export const NotFoundRouteComponent = () => {
  const { theme } = useContext(ThemeContext);
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <main className="min-h-screen min-w-full flex flex-col justify-center items-center text-center px-12 lg:px-0 relative isolate bg-background">
      <SquaredBackground />

      <div className="w-[200px] lg:w-[400px]">
        {theme == 'light' ? <CrashedRocket /> : <CrashedRocketDark />}
      </div>
      <h1 className="font-bold text-4xl pt-6 text-foreground">{t('not_found_page.title')}</h1>
      <h2 className="pt-2 text-secondary">{t('not_found_page.description')}</h2>

      <Button className="mt-8 px-12" onClick={() => navigate({ to: '/', replace: true })}>
        {t('not_found_page.backHomeButton')}
      </Button>
    </main>
  );
};
